import { Button } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

interface Props {
  hasPendingChanges: boolean;
  isSaving: boolean;
}

export function PendingChangesAction({ hasPendingChanges, isSaving }: Props) {
  const { t } = useTranslation();

  return (
    <Button
      variant="texas-solid"
      type="submit"
      isLoading={isSaving}
      isDisabled={!hasPendingChanges}
    >
      {t('article.management.saveChanges')}
    </Button>
  );
}
